<script>
/* eslint-disable no-undef */
/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */
/* eslint-disable no-console */
import { urlMethods } from "@/state/helpers";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";

import Swal from "sweetalert2";
import _ from "lodash";

import moment from "moment";

let defineCustomer = {
  district_id: 529,
  district_name: "Bình Thạnh",
  gender: 0,
  id: 5,
  member_group: "",
  member_percent: 0,
  name: "",
  phone: "",
  state_id: 172,
  state_name: "Hồ Chí Minh",
  birthday: "",
  transport_fee: 0,
};
export default {
  components: {
    Multiselect,
    DatePicker,
  },
  data: function() {
    return {
      customerSelected: null,
      customerPhone: "",
      customerName: "",
      customerBrithday: new Date(),
      customerVIP: "",
      customerGender: 4,
      isLoading: false,
      customerProvince: { id: 172, name: "Hồ Chí Minh" },
      customerDistrict: {},
      isDisabled: false,
      provinces: [],
      districts: [],
      listCustomers: [],
      dateRange: "2019-02-12",
      customerTransportFee: 0,
      formatDate: "D/M/YYYY",
    };
  },
  computed: {
    currentUser: function() {
      return this.$store.getters["auth/currentUser"];
    },
    currentTab: function() {
      return this.$store.getters["sale/currentTab"];
    },
    allDistrict: function() {
      return JSON.parse(JSON.stringify(this.$store.getters["sale/district"]));
    },
  },
  methods: {
    ...urlMethods,
    async saveCustomer() {
      let that = this;
      that.customerSelected.phone = that.customerPhone
        .replace(/\D/g, "")
        .replace(/[^\w\s]/gi, "");
      that.customerSelected.name = window.capitalizeWords(that.customerName);
      that.customerSelected.district_id =
        typeof that.customerDistrict != "undefined" &&
        typeof that.customerDistrict.id != "undefined"
          ? that.customerDistrict.id
          : 0;
      that.customerSelected.state_id =
        typeof that.customerProvince != "undefined" &&
        typeof that.customerProvince.id != "undefined"
          ? that.customerProvince.id
          : 0;
      that.customerSelected.birthday = that.customerBrithday;
      that.customerSelected.transport_fee = that.customerTransportFee;
      that.customerSelected.gender = that.customerGender;
      this.isDisabled = true;
      try {
        if (that.customerSelected.phone.length < 8) {
          throw "Số điện thoại quá ngắn";
        }
        if (that.customerSelected.name.length < 3) {
          throw "Họ tên quá ngắn";
        }
        if (that.customerSelected.state_id < 1) {
          throw "Chưa chọn Tỉnh/thành";
        }
        if (that.customerSelected.district_id < 1) {
          throw "Chưa chọn Quận/huyện";
        }
        let res = await that.postUrl({
          url: "save-customer",
          data: that.customerSelected,
        });
        if (
          typeof res == "undefined" ||
          typeof res.data == "undefined" ||
          typeof res.error == "undefined" ||
          typeof res.message == "undefined"
        ) {
          throw "Không thế kết nối server";
        }
        if (res.error) {
          throw res.message;
        }
        if (!res.data || typeof res.data.id == "undefined" || res.data.id < 1) {
          throw "Lỗi! Không thể cập nhật thông tin khách hàng";
        }
        that.customerSelected = res.data;
        this.$store.dispatch("sale/setCustomer", that.customerSelected);
        this.isDisabled = false;
        this.$bvModal.hide("modal-customer");
      } catch (error) {
        console.log(error);
        let text = typeof error == "string" ? error : JSON.stringify(error);
        this.$store.dispatch("sale/setNoti", { text: text, type: "error" });
        this.isDisabled = false;
      }
    },
    changeProvince() {
      let that = this;
      that.districts = that.allDistrict;
      that.districts = that.districts.filter(
        (item) => item.province_id == that.customerProvince.id
      );
    },
    changeCustomer() {
      let that = this;
      console.log(that.customerProvince);
    },
    changeDistrict() {
      let that = this;
    },
    clearCustomerSelected() {
      let that = this;
      this.customerSelected = null;
      this.setCustomerSelected();
      setTimeout(() => {
        that.$refs.customerSelected.searchEl.focus();
      }, 300);
    },
    setCustomerSelected() {
      let that = this;
      if (that.customerSelected != null) {
        that.customerPhone = that.customerSelected.phone;
        that.customerName = window.capitalizeWords(that.customerSelected.name);
        that.customerGender =
          that.customerSelected.gender === 0 ? 4 : that.customerSelected.gender;
        that.customerBrithday = that.customerSelected.birthday;
        that.customerProvince = {
          id: that.customerSelected.state_id,
          name: that.customerSelected.state_name,
        };
        that.customerVIP = that.customerSelected.member_group;
        that.changeProvince();

        // Sử dụng $nextTick để đảm bảo DOM đã được cập nhật
        this.$nextTick(() => {
          that.customerDistrict = {
            id: that.customerSelected.district_id,
            name: that.customerSelected.district_name,
            province_id: that.customerSelected.state_id,
          };
        });

        setTimeout(() => {
          that.$refs.customerName.focus();
        }, 300);
      }
    },

    asyncFind(search, loading) {
      if (search.length) {
        this.isLoading = true;
        this.search(loading, search, this);
        defineCustomer.phone = search;
      }
    },
    search: _.debounce(async (loading, query, that) => {
      try {
        let res = await that.postUrl({
          url: "search-customer",
          data: { phone: query },
        });
        if (
          typeof res == "undefined" ||
          typeof res.data == "undefined" ||
          typeof res.error == "undefined" ||
          typeof res.message == "undefined"
        ) {
          throw "Không thế kết nối server";
        }
        if (res.error) {
          throw res.message;
        }
        if (!res.data) {
          that.listCustomers = [];
        } else {
          that.listCustomers = JSON.parse(JSON.stringify(res.data));
        }
        if (
          typeof that.listCustomers[0] == "undefined" ||
          typeof that.listCustomers[0].id == "undefined"
        ) {
          let tempCustomer = JSON.parse(JSON.stringify(defineCustomer));
          tempCustomer.phone = query;
          that.listCustomers = [tempCustomer];
        }
      } catch (error) {
        console.log(error);
        let text = typeof error == "string" ? error : JSON.stringify(error);
        that.$store.dispatch("sale/setNoti", { text: text, type: "error" });
      }
      that.isLoading = false;
    }, 500),

    async setCustomerPhoneFromButton() {
      let that = this;
      try {
        that.customerSelected = {
            "id": 367507,
            "name": "Nội Bộ Tga - Khách Lẻ",
            "phone": "18001234",
            "district_id": 529,
            "state_id": 172,
            "birthday": "",
            "member_group": "Normal",
            "member_percent": 0,
            "gender": 4,
            "district_name": "Quận Bình Thạnh",
            "state_name": "Hồ Chí Minh"
        };
        await that.setCustomerSelected();
        await that.saveCustomer();
      } catch (error) {
        console.error(error);
      }
    }

    // setCustomerPhoneFromButton() {
    //   let that = this;
    //   // Đặt giá trị cho customerPhone khi click vào nút
    //   that.customerPhone = "18001234";

    //   // Tạo một đối tượng mới và thêm vào danh sách
    //   const newCustomer = {
    //     phone: that.customerPhone,
    //     // Các trường dữ liệu khác của đối tượng customer
    //   };

    //   // Thêm đối tượng mới vào đầu danh sách
    //   that.listCustomers.unshift(newCustomer);

    //   // Đặt giá trị cho customerSelected tương ứng
    //   that.customerSelected = newCustomer;

    //   that.customerName = "Khách vãng lai";
    // },

    // async setCustomerPhoneFromButton(loading, query){
    //   let that = this;
    //   try {
    //     query = '18001234'
    //     let res = await that.postUrl({
    //       url: "search-customer",
    //       data: { phone: query },
    //     });
    //     if (
    //       typeof res == "undefined" ||
    //       typeof res.data == "undefined" ||
    //       typeof res.error == "undefined" ||
    //       typeof res.message == "undefined"
    //     ) {
    //       throw "Không thế kết nối server";
    //     }
    //     if (res.error) {
    //       throw res.message;
    //     }
    //     if (!res.data) {
    //       that.listCustomers = [];
    //     } else {
    //       that.listCustomers = JSON.parse(JSON.stringify(res.data));
    //     }
    //     if (
    //       typeof that.listCustomers[0] == "undefined" ||
    //       typeof that.listCustomers[0].id == "undefined"
    //     ) {
    //       let tempCustomer = JSON.parse(JSON.stringify(defineCustomer));
    //       tempCustomer.phone = query;
    //       that.listCustomers = [tempCustomer];
    //     }
    //   } catch (error) {
    //     console.log(error);
    //     let text = typeof error == "string" ? error : JSON.stringify(error);
    //     that.$store.dispatch("sale/setNoti", { text: text, type: "error" });
    //   }
    //   loading(false);
    // }
  },
  mounted() {
    let that = this;
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      if (modalId == "modal-customer") {
        that.provinces = JSON.parse(
          JSON.stringify(that.$store.getters["sale/province"])
        );
        this.customerSelected =
          typeof that.currentTab.info.customer != "undefined" &&
          typeof that.currentTab.info.customer.id != "undefined"
            ? that.currentTab.info.customer
            : null;
        this.setCustomerSelected();
        setTimeout(() => {
          if (that.customerSelected == null)
            that.$refs.customerSelected.searchEl.focus();
        }, 100);
      }
    });
  },
};
</script>

<template>
  <b-modal id="modal-customer" title="Khách hàng" title-class="font-18" hide-footer>
    <b-form-group v-if="customerSelected == null || customerSelected.phone == ''" class="mb-3" label-cols-lg="3" label="Số điện thoại" label-for="customerSelected">
      <v-select ref="customerSelected" v-model="customerSelected" @input="setCustomerSelected" label="phone" :options="listCustomers" @search="asyncFind">
        <template slot="no-options">Nhập số điện thoại để tìm</template>
        <template slot="option" slot-scope="option" @keyup.enter="selectFirstItem">{{ option.phone }} - {{ option.name }}</template>
        <template slot="selected-option" slot-scope="option">{{ option.phone }}</template>
      </v-select>
    </b-form-group>
    <b-form-group v-else class="mb-2 customer-phone-box" label-cols-lg="3" label="Số điện thoại" label-for="customerPhone">
      <b-form-input :disabled="isDisabled" @keyup.enter="saveCustomer" ref="customerPhone" autocomplete="off" for="customerPhone" v-model="customerPhone"></b-form-input>
      <i @click="clearCustomerSelected" class="bx bx-x"></i>
    </b-form-group>
    <b-form-group class="mb-2" label-cols-lg="3" label="Họ tên" label-for="customerName">
      <b-form-input ref="customerName" :disabled="isDisabled" @keyup.enter="saveCustomer" autocomplete="off" for="customerName" v-model="customerName"></b-form-input>
    </b-form-group>
    <b-form-group class="mb-2 form-group-gender" label-cols-lg="3" label="Giới tính" label-for="customerGender">
      <b-form-radio v-model="customerGender" class="form-check-gender" value="4" :disabled="isDisabled" plain>Nam</b-form-radio>
      <b-form-radio class="form-check-gender" v-model="customerGender" value="1" :disabled="isDisabled" plain>Nữ</b-form-radio>
    </b-form-group>
    <b-form-group class="mb-2" label-cols-lg="3" label="Ngày Sinh" label-for="customerBrithday">
      <date-picker v-model="customerBrithday" append-to-body lang="vn" value-type="format" :format="formatDate"></date-picker>
      <code>Định dạng mẫu d/m/yyyy - 1/1/2000</code>
    </b-form-group>
    <b-form-group class="mb-3" label-cols-lg="3" label="Tỉnh/thành" label-for="customerProvince">
      <multiselect @input="changeProvince" v-model="customerProvince" selectlabel="Enter để chọn" :disabled="isDisabled" track-by="id" label="name" placeholder="Chọn tỉnh thành" :options="provinces" :allow-empty="false"></multiselect>
    </b-form-group>
    <b-form-group class="mb-3" label-cols-lg="3" label="Quận/huyện" label-for="customerDistrict">
      <multiselect @input="changeDistrict" v-model="customerDistrict" selectlabel="Enter để chọn" :disabled="isDisabled" track-by="id" label="name" placeholder="Chọn quận huyện" :options="districts" :allow-empty="false"></multiselect>
    </b-form-group>
    <b-form-group class="mb-3" label-cols-lg="3" label="Group member" label-for="customerVIP">
      <b-form-input ref="customerVIP" readonly="readonly" autocomplete="off" for="customerVIP" v-model="customerVIP"></b-form-input>
    </b-form-group>
    <div class="flex-box">
      <div class="flex-full"><button @click="setCustomerPhoneFromButton" class="custom-button">Khách vãng lai</button></div>
        <div class="text-right" v-if="!(customerSelected == null || customerSelected.phone == '')">
          <i v-if="isDisabled" class="fas fa-spinner fa-spin"></i>
          <b-button variant="primary" @click="saveCustomer" :disabled="isDisabled">
            <i class="bx bx-check"></i>Xác nhận
          </b-button>
        </div>
    </div>
  </b-modal>
</template>

<style scoped>
.ctwidth {
  width: 500px;
}
</style>
